import React from 'react';
import PropTypes from 'prop-types';
import FileUploadViewer from './file-upload-viewer.js';
import 'lodash';
import 'wix-rich-content-common';
import 'wix-rich-content-common/dist/statics/schemas/plugin-file-upload.schema.json';
import './file-upload-viewer-4d0114d5.js';
import './style-inject.es-746bb8ed.js';
import 'wix-rich-content-common/libs/Tooltip';
import 'classnames';
import './types.js';
import './pdfViewer/pdfConsts.js';
import './icons/errorIcon.js';
import './icons/LoaderIcon.js';
import './icons/readyIcon.js';
import './icons/downloadIcon.js';
import './icons/getIcon.js';
import './icons/xlsIcon.js';
import './icons/vid-aud-icon.js';
import './icons/pptIcon.js';
import './icons/pdfIcon.js';
import './icons/otherIcon.js';
import './icons/imageIcon.js';
import './icons/folderIcon.js';
import './icons/docIcon.js';
import './pdfViewer/pdfViewer.js';
import './pdfViewer/pdfViewSDKClient.js';

function FileUploadComponent(props) {
  const {
    componentData,
    theme,
    setComponentUrl,
    t,
    isMobile,
    tempData,
    isLoading,
    locale,
    settings
  } = props;
  const tempDataPlaceHolder = tempData || (componentData.tempData ? componentData : void 0);
  return /* @__PURE__ */ React.createElement(
    FileUploadViewer,
    {
      componentData,
      isLoading: isLoading || componentData.tempData,
      theme,
      setComponentUrl,
      t,
      isMobile,
      tempDataPlaceHolder,
      locale,
      settings
    }
  );
}
FileUploadComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  setComponentUrl: PropTypes.func,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  tempData: PropTypes.object,
  isLoading: PropTypes.bool,
  locale: PropTypes.string,
  settings: PropTypes.object
};
FileUploadComponent.defaultProps = {
  settings: {}
};

export { FileUploadComponent as Component };
//# sourceMappingURL=file-upload-component.js.map
